/* eslint-disable eqeqeq */
import React, { useCallback, useState } from "react";
import { API, fileUpload, get } from "../../../../../config";
import { toast } from "react-toastify";
import { Button, Form, FormControl, Modal } from "react-bootstrap";
import Spin from "../../../../common/Spin";
import ContractorSelectWithTA from "../../../../common/ContractorSelectWithTA";
import { useParams } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import Select from "react-select";
import { getContractorDetail } from "../../../sub-contractors/components/SubContractorHelper";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import EmailChipsInput from "../../../../common/EmailChipsInput";
import {
  AddDocumentContractSchema,
  AddDocumentSchema,
} from "../../../../common/Validation";

const AddDocumentModal = ({
  toggleAddModal,
  handleAdd,
  showAdd,
  documentType,
  editData = "",
  edit = false,
}) => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const projectId = params?.project_id;
  // eslint-disable-next-line no-unused-vars
  const [contractorDetails, setContractorDetails] = useState();
  const [disableState, setDisableState] = useState(false);
  const [addContract, setAddContract] = useState(edit ? true : false);

  const [paymentScheduleOptions, setPaymentScheduleOptions] = useState([]);
  const [contractOptions, setContractOptions] = useState([
    editData?.contract && {
      label: editData?.contract?.contract_number,
      value: editData?.contract?.id,
      ...editData?.contract,
    },
    { label: <strong>+ New Contract</strong>, value: "new" },
  ]);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFiles = (files, setFieldValue, multiple) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/msword",
      "application/pdf",
    ];

    const validFiles = files.filter((file) => allowedTypes.includes(file.type));

    if (validFiles.length > 0 && multiple) {
      setUploadedFiles((prev) => [...prev, ...validFiles]);
      setFieldValue("documents", [...uploadedFiles, ...validFiles]);
    } else if (validFiles.length > 0) {
      setUploadedFiles([...validFiles]);
      setFieldValue("documents", [...validFiles]);
    } else {
      toast.error("Invalid file type.");
    }
  };

  const fetchContracts = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_CONTRACTS}?contact_id=${id}&builder_project_id=${projectId}&limit=-1&page=1`
        );
        const list =
          data &&
          data?.data?.data?.length > 0 &&
          data?.data?.data?.map((item) => {
            const list = {
              label: item?.contract_number,
              value: item?.id,
              ...item,
            };
            return list;
          });
        setContractOptions(
          list
            ? [
                ...list,
                { label: <strong>+ New Contract</strong>, value: "new" },
              ]
            : [{ label: <strong>+ New Contract</strong>, value: "new" }]
        );
        setLoading(false);
        // const list = data.data;s
        // setContractOptions(list);
        return data.data;
      } catch (error) {
        setLoading(false);
        setContractOptions([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    [projectId]
  );

  const fetchPaymentSchedules = useCallback(
    async (selectedMainContacts, selectedMainContracts) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${
            API.PAYMENT_SCHEDULES
          }?builder_project_id=${projectId}&limit=-1&page=1&contacts=${
            selectedMainContacts ? selectedMainContacts : ""
          }&contracts=${
            selectedMainContracts ? selectedMainContracts : ""
          }&trust_type=1
          `
        );

        setLoading(false);
        const paymentScheduleList =
          data && data?.data?.data?.length > 0
            ? data?.data?.data?.map((item) => {
                const list = {
                  label: item?.invoice_number,
                  value: item?.id,
                  ...item,
                };
                return list;
              })
            : [];

        setPaymentScheduleOptions(paymentScheduleList);
        return data.data;
      } catch (error) {
        setLoading(false);
        setPaymentScheduleOptions([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    [projectId]
  );

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const formData = new FormData();
      values.contract =
        values?.contract?.value === "new" ? "" : values?.contract;
      if (values.contract_value) {
        values.contract_value = Number(
          `${values.contract_value}`.replace(/,/g, "")
        );
      }

      if (values.contract_value_exc) {
        values.contract_value_exc = Number(
          `${values.contract_value_exc}`.replace(/,/g, "")
        );
      }

      if (values.retention_amount) {
        values.retention_amount = Number(
          `${values?.retention_amount}`.replace(/,/g, "")
        );
      } else {
        values.retention_amount = "0";
      }

      if (values.retention_percentage) {
        values.retention_percentage = Number(
          `${values?.retention_percentage}`.replace("%", "")
        );
      } else {
        values.retention_percentage = "0";
      }

      for (const key in values) {
        if (key !== "fileChipURL" && key !== "documents") {
          if (key === "file_url") {
            if (values[key]) {
              let valueData = values[key].replace(/\s*,\s*/g, ",")?.split(",");
              for (
                let valueIndex = 0;
                valueIndex < valueData?.length;
                valueIndex++
              ) {
                formData.append(
                  `file_urls[${valueIndex}]`,
                  valueData[valueIndex]
                );
              }
            }
          } else if (key === "contract") {
            if (values[key]) {
              formData.append("contract_id", values[key]?.value);
            }
          } else if (key === "document_type") {
            if (values[key]) {
              formData.append("document_type", values[key]?.value);
            }
          } else if (key === "contact_id") {
            if (values[key]) {
              formData.append("contact_id", values[key]?.id);
            }
          } else {
            formData.append(key, values[key]);
          }
        }
      }
      uploadedFiles.forEach((file, index) => {
        formData.append(`documents[${index}]`, file);
      });
      formData.append("builder_project_id", projectId);
      const { data } = await fileUpload(`${API.UPLOAD_DOCUMENT}`, formData);
      setLoading(false);
      toast.success(data?.message);
      toggleAddModal();
      handleAdd();
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
      } else {
        toast.error(error?.message);
      }
      return null;
    }
  };

  const getContractor = async (contractorId) => {
    try {
      setLoading(true);
      const data = await getContractorDetail(contractorId);
      const contractorData = data ? data : {};
      if (contractorData?.id) {
        if (
          contractorData?.account_name &&
          contractorData?.account_number &&
          contractorData?.bsb
        ) {
          setDisableState(false);
        } else {
          setDisableState(true);
          toast.error("Please add bank details of selected contractor.");
        }
      }
      setLoading(false);
    } catch (e) {
      toast.error("Something went wrong.");
    }
  };

  const handleContractorSelect = async (
    contractor,
    setFieldValue,
    document_type
  ) => {
    setFieldValue("contact_id", contractor);
    setFieldValue("contract", "");
    setFieldValue("payment_schedule_id", "");
    setFieldValue("document_type", "");
    setFieldValue("contract_number", "");
    setFieldValue("contract_value", "");
    setFieldValue("contract_value_exc", "");
    setFieldValue("retention_percentage", "");
    setFieldValue("retention_amount", "");
    setFieldValue("file_url", "");
    setFieldValue("fileChipURL", "");
    setFieldValue("documents", []);
    setAddContract(false);
    setContractorDetails(contractor);
    await getContractor(contractor?.id, contractor);
    await fetchContracts(contractor?.id);
    if (document_type?.value == 4) {
      await fetchPaymentSchedules(contractor?.id, "");
    }
  };

  const documentTypeOptions = [
    { label: "Copy Of Contracts", value: 1 },
    { label: "Any Contract Variation/Amendment Documents", value: 2 },
    // { label: "Payment Claims/ Schedules Given And Received", value: 3 },
    { label: "Supporting Documents", value: 4 },
    { label: "Other Docs", value: 5 },
  ];

  const handleDocumentDelete = (index, setFieldValue) => {
    // Remove the file from the uploadedFiles state
    setUploadedFiles((prevFiles) => {
      const updatedFiles = prevFiles.filter((_, i) => i !== index);

      // Update Formik state
      setFieldValue("documents", updatedFiles);

      return updatedFiles;
    });
  };
  return (
    <Modal
      size="lg"
      show={showAdd}
      onHide={toggleAddModal}
      dialogClassName="modal-50w small-popup review-popup small-review doc-modal"
      aria-labelledby="contained-modal-title-vcenter"
      className="project-section"
      centered
    >
      <Modal.Header className="mb-0" closeButton>
        {edit ? "Make Variation" : "Add Document"}
      </Modal.Header>
      <Modal.Body>
        {loading && <Spin />}
        {console.log(editData)}
        <Formik
          initialValues={{
            contact_id:
              edit && editData?.contact
                ? editData?.contact
                : contractorDetails
                ? contractorDetails
                : "",
            contract:
              edit && editData?.contract
                ? {
                    label: editData?.contract?.contract_number,
                    value: editData?.contract?.id,
                    ...editData?.contract,
                  }
                : "",
            contract_number:
              edit && editData?.contract?.contract_number
                ? editData?.contract?.contract_number
                : "",
            contract_value:
              edit && editData?.contract?.contract_value
                ? editData?.contract?.contract_value
                : "",
            contract_value_exc:
              edit && editData?.contract?.contract_value
                ? Number(
                    Number(
                      Number(
                        editData?.contract?.contract_value
                          ?.toString()
                          ?.replace(/,/g, "")
                      ) / 1.1
                    ).toFixed(2)
                  )
                : "",
            retention_percentage:
              edit && editData?.contract?.retention_percentage
                ? editData?.contract?.retention_percentage
                : "",
            retention_amount:
              edit && editData?.contract?.retention_amount
                ? editData?.contract?.retention_amount
                : "",
            document_type: edit
              ? {
                  label: "Any Contract Variation/Amendment Documents",
                  value: 2,
                }
              : "",
            documents: [],
            file_url: "",
            fileChipURL: "",
          }}
          name="supplierForm"
          enableReinitialize={true}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
          validateOnBlur={true}
          validateOnChange={true}
          validationSchema={
            addContract ? AddDocumentContractSchema : AddDocumentSchema
          }
        >
          {({
            values,
            setErrors,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => {
            return (
              <>
                {loading && <Spin />}
                <form
                  onSubmit={handleSubmit}
                  noValidate
                  className="entry-section"
                >
                  <div className="form-box" style={{ textAlign: "left" }}>
                    <div className="form-group half-width builder-firm">
                      <label>
                        <span className="required">*</span>Subcontractor
                      </label>
                      <ContractorSelectWithTA
                        regionName={"0"}
                        projectId={projectId}
                        value={values?.contact_id ? values?.contact_id : null}
                        onChange={(contractor) => {
                          handleContractorSelect(
                            contractor,
                            setFieldValue,
                            values?.document_type
                          );
                        }}
                        business={true}
                        className="contactname-select"
                        placeholder="Select Subcontractor"
                        isClearable={false}
                        isDisabled={edit}
                      />
                      <span
                        className="text-danger"
                        style={{ color: "red", fontSize: "20px" }}
                      >
                        <ErrorMessage name="contact_id" />
                      </span>
                    </div>

                    <div className="form-group half-width">
                      <label>
                        <span className="required">*</span>
                        Document Type
                      </label>
                      <Select
                        options={
                          values?.contract?.value === "new"
                            ? documentTypeOptions
                            : documentTypeOptions
                        }
                        onChange={async (e) => {
                          if (e?.value === 2) {
                            setFieldValue(
                              "contract_number",
                              values?.contract?.contract_number
                                ? values?.contract?.contract_number
                                : ""
                            );
                            setFieldValue(
                              "contract_value",
                              values?.contract?.contract_value
                                ? values?.contract?.contract_value
                                : ""
                            );
                            let contract_value_exc = values?.contract
                              ?.contract_value
                              ? Number(
                                  Number(
                                    Number(
                                      values?.contract?.contract_value
                                        ?.toString()
                                        ?.replace(/,/g, "")
                                    ) / 1.1
                                  ).toFixed(2)
                                )
                              : "";

                            setFieldValue(
                              "contract_value_exc",
                              contract_value_exc ? contract_value_exc : ""
                            );
                            setFieldValue(
                              "retention_percentage",
                              values?.contract?.retention_percentage
                                ? values?.contract?.retention_percentage
                                : ""
                            );
                            setFieldValue(
                              "retention_amount",
                              values?.contract?.retention_amount
                                ? values?.contract?.retention_amount
                                : ""
                            );
                            setAddContract(true);
                          } else if (e?.value === 1) {
                            setAddContract(true);
                            setFieldValue("contract_number", "");
                            setFieldValue("contract_value", "");
                            setFieldValue("contract_value_exc", "");
                            setFieldValue("retention_percentage", "");
                            setFieldValue("retention_amount", "");
                          } else if (e?.value === 4) {
                            await fetchPaymentSchedules(
                              values?.contact_id?.id,
                              values?.contract?.value
                            );
                            setFieldValue("payment_schedule_id", "");

                            setAddContract(false);
                          } else {
                            setAddContract(false);
                          }
                          setFieldValue("document_type", e);
                          setFieldValue("file_url", "");
                          setFieldValue("fileChipURL", "");
                          setFieldValue("documents", []);
                          setUploadedFiles([]);
                        }}
                        value={
                          addContract
                            ? values?.document_type?.value === 2
                              ? documentTypeOptions?.find(
                                  (item) => item.value === 2
                                )
                              : documentTypeOptions?.find(
                                  (item) => item.value === 1
                                )
                            : values?.document_type
                            ? documentTypeOptions?.find(
                                (item) =>
                                  item.value === values?.document_type?.value
                              )
                            : ""
                        }
                        placeholder="Select Document Type"
                        name="document_type"
                        classNamePrefix="selectbox"
                        isClearable
                        isDisabled={edit}
                      />
                      <span
                        className="text-danger"
                        style={{ color: "red", fontSize: "20px" }}
                      >
                        <ErrorMessage name="document_type" />
                      </span>
                    </div>
                    {values?.document_type?.value == 4 && (
                      <div className="form-group half-width">
                        <label>Payment Schedules</label>
                        <Select
                          options={paymentScheduleOptions}
                          onChange={async (e) => {
                            setFieldValue("payment_schedule_id", e?.value);
                            let contractData = contractOptions?.find(
                              (contractItem) =>
                                contractItem?.value === e?.contract_id
                            );
                            setFieldValue("contract", contractData);
                          }}
                          value={
                            values?.payment_schedule_id
                              ? paymentScheduleOptions?.find(
                                  (item) =>
                                    item.value === values?.payment_schedule_id
                                )
                              : ""
                          }
                          isClearable
                          // isDisabled={addContract}
                          placeholder="Select Payment Schedule"
                          name="payment_schedule_id"
                          classNamePrefix="selectbox"
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="payment_schedule_id" />
                        </span>
                      </div>
                    )}
                    {values?.document_type?.value != 1 && (
                      <div className="form-group half-width">
                        <label>
                          {values?.document_type?.value == 4 &&
                          values?.payment_schedule_id ? (
                            <></>
                          ) : (
                            <span className="required">*</span>
                          )}
                          Contract/Agreement Number
                        </label>
                        <Select
                          options={contractOptions}
                          onChange={async (e) => {
                            if (!e) {
                              if (values?.document_type?.value == 1) {
                                setFieldValue("document_type", "");
                              }
                              setFieldValue("contract", "");
                              setFieldValue("payment_schedule_id", "");
                              setAddContract(false);
                              setFieldValue("contract_number", "");
                              setFieldValue("contract_value", "");
                              setFieldValue("contract_value_exc", "");
                              setFieldValue("retention_percentage", "");
                              setFieldValue("retention_amount", "");
                            } else {
                              if (e?.value === "new") {
                                // setFieldValue("contract", e);
                                setFieldValue(
                                  "document_type",
                                  documentTypeOptions?.find(
                                    (item) => item.value === 1
                                  )
                                );
                                setFieldValue("contract_number", "");
                                setFieldValue("contract_value", "");
                                setFieldValue("contract_value_exc", "");
                                setFieldValue("retention_percentage", "");
                                setFieldValue("retention_amount", "");
                                setAddContract(true);
                              } else if (values?.document_type?.value === 2) {
                                setFieldValue(
                                  "contract_number",
                                  e?.contract_number ? e?.contract_number : ""
                                );
                                setFieldValue(
                                  "contract_value",
                                  e?.contract_value ? e?.contract_value : ""
                                );
                                let contract_value_exc = e?.contract_value
                                  ? Number(
                                      Number(
                                        Number(
                                          e?.contract_value
                                            ?.toString()
                                            ?.replace(/,/g, "")
                                        ) / 1.1
                                      ).toFixed(2)
                                    )
                                  : "";

                                setFieldValue(
                                  "contract_value_exc",
                                  contract_value_exc ? contract_value_exc : ""
                                );

                                setFieldValue(
                                  "retention_percentage",
                                  e?.retention_percentage
                                    ? e?.retention_percentage
                                    : ""
                                );
                                setFieldValue(
                                  "retention_amount",
                                  e?.retention_amount ? e?.retention_amount : ""
                                );
                                setAddContract(true);
                                setFieldValue("contract", e);
                              } else {
                                setAddContract(false);
                                setFieldValue("contract", e);
                              }
                              if (values?.document_type?.value == 4) {
                                await fetchPaymentSchedules(
                                  values?.contact_id?.id,
                                  e?.value
                                );
                              }
                            }
                          }}
                          value={
                            addContract && values?.document_type?.value == 1
                              ? contractOptions?.find(
                                  (item) => item.value === "new"
                                )
                              : values?.contract
                              ? contractOptions?.find(
                                  (item) =>
                                    item.value === values?.contract?.value
                                )
                              : ""
                          }
                          isClearable
                          // isDisabled={addContract}
                          placeholder="Select Contract Number"
                          name="contract"
                          classNamePrefix="selectbox"
                          isDisabled={edit}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="contract" />
                        </span>
                      </div>
                    )}
                    {addContract && (
                      <>
                        <div className="form-group half-width">
                          <label>
                            <span className="required">*</span>New Contract
                            Number
                          </label>
                          <input
                            type="text"
                            name={`contract_number`}
                            value={
                              values?.contract_number
                                ? values?.contract_number
                                : ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            autoComplete="off"
                            onKeyPress={(e) => {
                              e.which === 13 && e.preventDefault();
                            }}
                          />
                          <span
                            className="text-danger"
                            style={{ color: "red", fontSize: "20px" }}
                          >
                            <ErrorMessage name="contract_number" />
                          </span>
                        </div>

                        <div className="form-group half-width">
                          <label>
                            <span className="required">*</span>New Contract
                            Value(Inc. GST)
                          </label>
                          <NumberFormat
                            type="text"
                            name={`contract_value`}
                            value={
                              values.contract_value
                                ? values?.contract_value
                                : ""
                            }
                            onChange={handleChange}
                            decimalScale={2}
                            thousandSeparator={true}
                            allowNegative={false}
                            onBlur={(e) => {
                              if (e?.target?.value === "") {
                                setFieldValue(`contract_value_exc`, "");
                                setFieldValue(`retention_amount`, "");
                                setFieldValue(`retention_percentage`, "");
                              } else {
                                let contract_value_exc = Number(
                                  Number(
                                    Number(
                                      e?.target?.value?.replace(/,/g, "")
                                    ) / 1.1
                                  ).toFixed(2)
                                );
                                setFieldValue(
                                  `contract_value_exc`,
                                  contract_value_exc
                                );
                                if (
                                  values?.retention_amount &&
                                  values?.retention_percentage
                                ) {
                                  let retention_amount =
                                    (Number(
                                      e?.target?.value?.replace(/,/g, "")
                                    ) *
                                      Number(
                                        values?.retention_percentage
                                          ?.toString()
                                          ?.replace("%", "")
                                      )) /
                                    100;
                                  setFieldValue(
                                    `retention_amount`,
                                    retention_amount
                                  );
                                  setFieldValue(
                                    `retention_percentage`,
                                    (100 *
                                      Number(
                                        retention_amount
                                          ?.toString()
                                          ?.replace(/,/g, "")
                                      )) /
                                      Number(
                                        e?.target?.value?.replace(/,/g, "")
                                      )
                                  );
                                }
                              }
                              setFieldValue(`contract_value`, e?.target?.value);
                            }}
                          />
                          <span
                            className="text-danger"
                            style={{ color: "red", fontSize: "20px" }}
                          >
                            <ErrorMessage name="contract_value" />
                          </span>
                        </div>

                        <div className="form-group half-width">
                          <label>
                            <span className="required">*</span>Contract
                            Value(Ex. GST)
                          </label>
                          <NumberFormat
                            type="text"
                            name={`contract_value_exc`}
                            value={
                              values.contract_value_exc
                                ? values?.contract_value_exc
                                : ""
                            }
                            onChange={handleChange}
                            decimalScale={2}
                            thousandSeparator={true}
                            allowNegative={false}
                            disabled
                            onBlur={(e) => {
                              if (e?.target?.value === "") {
                                setFieldValue(`contract_value`, "");
                                setFieldValue(`retention_amount`, "");
                                setFieldValue(`retention_percentage`, "");
                              } else {
                                let contract_value = Number(
                                  Number(
                                    Number(
                                      e?.target?.value?.replace(/,/g, "")
                                    ) +
                                      Number(
                                        e?.target?.value?.replace(/,/g, "")
                                      ) *
                                        0.1
                                  ).toFixed(2)
                                );
                                setFieldValue(`contract_value`, contract_value);
                                if (
                                  values?.retention_amount &&
                                  values?.retention_percentage
                                ) {
                                  let retention_amount =
                                    (Number(contract_value) *
                                      Number(
                                        values?.retention_percentage
                                          ?.toString()
                                          ?.replace("%", "")
                                      )) /
                                    100;
                                  setFieldValue(
                                    `retention_amount`,
                                    retention_amount
                                  );
                                  setFieldValue(
                                    `retention_percentage`,
                                    (100 *
                                      Number(
                                        retention_amount
                                          ?.toString()
                                          ?.replace(/,/g, "")
                                      )) /
                                      Number(contract_value)
                                  );
                                }
                              }
                              setFieldValue(
                                `contract_value_exc`,
                                e?.target?.value
                              );
                            }}
                          />
                          <span
                            className="text-danger"
                            style={{ color: "red", fontSize: "20px" }}
                          >
                            <ErrorMessage name="contract_value_exc" />
                          </span>
                        </div>

                        <div className="form-group half-width">
                          <label>
                            {/* <span className="required">*</span> */}
                            Retention Percentage(%)
                          </label>
                          <NumberFormat
                            type="text"
                            name={`retention_percentage`}
                            value={
                              values.retention_percentage
                                ? values?.retention_percentage
                                : "0%"
                            }
                            suffix="%"
                            onChange={handleChange}
                            onBlur={(e) => {
                              setFieldValue(
                                `retention_percentage`,
                                e?.target?.value
                              );
                              if (e?.target?.value === "") {
                                setFieldValue(`retention_amount`, "");
                              } else {
                                setFieldValue(
                                  `retention_amount`,
                                  (Number(
                                    values.contract_value
                                      ?.toString()
                                      ?.replace(/,/g, "")
                                  ) *
                                    Number(
                                      e?.target?.value?.replace("%", "")
                                    )) /
                                    100
                                );
                              }
                            }}
                            decimalScale={2}
                            allowNegative={false}
                            isAllowed={(values) => {
                              const { floatValue } = values;
                              return !floatValue || floatValue <= 100;
                            }}
                          />
                          <span
                            className="text-danger"
                            style={{ color: "red", fontSize: "20px" }}
                          >
                            <ErrorMessage name="retention_percentage" />
                          </span>
                        </div>

                        <div className="form-group half-width">
                          <label>
                            {/* <span className="required">*</span> */}
                            Retention Value($)
                          </label>
                          <NumberFormat
                            type="text"
                            name={`retention_amount`}
                            value={
                              values.retention_amount
                                ? values?.retention_amount
                                : "0"
                            }
                            decimalScale={2}
                            onBlur={(e) => {
                              setFieldValue(
                                `retention_amount`,
                                e?.target?.value
                              );
                              if (e?.target?.value === "") {
                                setFieldValue(`retention_percentage`, "");
                              } else {
                                setFieldValue(
                                  `retention_percentage`,
                                  (100 *
                                    Number(
                                      e?.target?.value?.replace(/,/g, "")
                                    )) /
                                    Number(
                                      values?.contract_value
                                        ?.toString()
                                        ?.replace(/,/g, "")
                                    )
                                );
                              }
                            }}
                            thousandSeparator={true}
                            allowNegative={false}
                            onChange={handleChange}
                          />
                          <span
                            className="text-danger"
                            style={{ color: "red", fontSize: "20px" }}
                          >
                            <ErrorMessage name="retention_amount" />
                          </span>
                        </div>
                      </>
                    )}

                    <div className="upload-div document-upload email-form">
                      <label>
                        {!addContract && <span className="required">*</span>}
                        Document Upload
                      </label>

                      <div className="modal-body">
                        <Form>
                          <div className="upload-file">
                            <FormControl
                              accept={
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/jpeg, image/jpg, image/x-png, .doc, .docx, .pdf"
                              }
                              type="file"
                              name="documents"
                              className="form-control"
                              id="documents"
                              multiple={
                                values?.document_type?.value === 4 ||
                                values?.document_type?.value === 5
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                handleFiles(
                                  Array.from(e.target.files),
                                  setFieldValue,
                                  values?.document_type?.value === 4 ||
                                    values?.document_type?.value === 5
                                    ? true
                                    : false
                                );
                              }}
                            />
                            <span>
                              <p className="ant-upload-drag-icon">
                                <FontAwesomeIcon icon={faUpload} size="3x" />
                              </p>
                              <p className="ant-upload-text">
                                Click or drag file to this area to upload
                              </p>
                            </span>
                          </div>
                          {uploadedFiles && uploadedFiles?.length > 0 && (
                            <div className="file-list-tags">
                              <label>Document List</label>
                              {uploadedFiles?.map((item, index) => {
                                return (
                                  <div key={index} className="tag">
                                    <span title={item.name}>{item.name}</span>
                                    <div className="remove">
                                      <FontAwesomeIcon
                                        icon={faXmarkCircle}
                                        onClick={() => {
                                          handleDocumentDelete(
                                            index,
                                            setFieldValue
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                          <span
                            className="text-danger"
                            style={{ color: "red", fontSize: "20px" }}
                          >
                            <ErrorMessage name="documents" />
                          </span>
                          <div className="or-section-row">
                            <hr />
                            OR
                            <hr />
                          </div>
                          <div className="form-group full-width">
                            <label>
                              {!addContract && (
                                <span className="required">*</span>
                              )}
                              File URL
                            </label>
                            {values?.document_type?.value === 4 ||
                            values?.document_type?.value === 5 ? (
                              <>
                                <EmailChipsInput
                                  label=""
                                  onEmailsChange={(urls) =>
                                    setFieldValue("file_url", urls.join(","))
                                  }
                                  placeholder="Enter File URL and Press Comma or Enter"
                                  setFieldValue={setFieldValue}
                                  keyData="fileChipURL"
                                  value={
                                    values?.fileChipURL
                                      ? values?.fileChipURL
                                      : ""
                                  }
                                  emailInput={false}
                                />
                                <div className="text-danger error-message">
                                  <ErrorMessage name="fileChipURL" />
                                </div>
                              </>
                            ) : (
                              <>
                                <input
                                  type="text"
                                  name={`file_url`}
                                  value={
                                    values?.file_url ? values?.file_url : ""
                                  }
                                  placeholder="Enter File URL"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  autoComplete="off"
                                  onKeyPress={(e) => {
                                    e.which === 13 && e.preventDefault();
                                  }}
                                />
                                <div className="text-danger error-message">
                                  <ErrorMessage name="file_url" />
                                </div>
                              </>
                            )}
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <Button
                      type="submit"
                      className="btn btn-primary"
                      disabled={disableState}
                    >
                      Save
                    </Button>
                    <Button
                      className="btn btn-secondary"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        toggleAddModal();
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </form>
              </>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddDocumentModal;
